export const MIN_SLUG_LENGTH = 3;
export const MAX_PASSCODE_LENGTH = 10;
